module.exports = __webpack_public_path__ + "static/media/email.b90c2773.svg";